import request from '@utils/request';
import { Response } from '@features/state';
import { RoomSettingsSchema } from './schema';

export async function getRoomSettings({ siteSlug }: { siteSlug: string }) {
  const response = await request.v2.get(`/store/pages/site/${siteSlug}/settings/rooms`);
  return Response(RoomSettingsSchema).parse(response.data);
}
